<template>
  <v-flex class="transferFunds fill-height" data-qa="swiftpayments-flex-lutbgq">
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <v-flex v-if="!reviewScreen" xs12 sm12 md12 lg12 xl12>
      <v-navigation-drawer
        v-model="openPayee"
        :width="360"
        height="90vh"
        :close-on-click="false"
        absolute
        bottom
        right
        floating
        class="transferFunds--payeeList">
        <v-card height="100%">
          <v-toolbar color="white" light>
            <v-toolbar-title>
              <v-list-item-title v-if="!enablePayeeForm" class="text-h6">{{ $t("internationalPayments.selectPayeeLabel") }}
              </v-list-item-title>
              <v-list-item-title v-if="enablePayeeForm" class="text-h6">
                {{ $t("internationalPayments.addPayeeHeading") }}
              </v-list-item-title>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click.stop="onClosePayeeDrawer" icon >
              <v-icon class="material-symbols-outlined">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider />
          <!-- Payees -->
          <v-list-item two-line v-if="!enablePayeeForm">
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field
                  v-model="searchPayee"
                  :label="$t('internationalPayments.payeeSearchLabel')"
                  :color="primaryColor"
                  prepend-inner-icon="mdi-magnify"
                  class="transferFunds--custom-textfield"
                  clearable
                  filled
                />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list v-if="!enablePayeeForm" two-line flat class="mt-n8">
            <v-row v-if="enableSwiftPayee && !isSmeLogin" no-gutters justify="end" class="px-3">
              <v-btn
                @click="enablePayeeForm = true"
                :color="primaryColor"
                dark
                class="text-capitalize">
              {{ $t("internationalPayments.addPayeeBtn") }}
              </v-btn>
            </v-row>
            <template v-if="payeeSearchFilter.length">
             <template v-for="(item, index) in payeeSearchFilter">
              <v-list-item
                :key="item.beneficiaryAccountNumber"
                @click="togglePayee(item)"
                :data-qa="`internationalpayments-list-item-8swhyfk-${index}`">
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.name"
                    class="text--primary"
                  />
                  <v-list-item-subtitle v-text="item.beneficiaryAccountNumber" />
                  <v-list-item-subtitle v-text="`${item.beneficiaryBankBic} (BIC Code)`" />
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="showDivider(index, beneficiaryList)"
                :key="index"
              />
             </template>
            </template>
            <v-row v-else no-gutters justify="center" class="pa-2">
              {{ $t('payee.notAvailable')}}
            </v-row>
          </v-list>
          <v-list v-if="enablePayeeForm">
            <v-list-item>
              <v-list-item-content>
                <v-form ref="payeeForm" v-model="isPayeeFormValid">
                  <v-text-field
                    v-model="payeeForm.accountName"
                    :label="$t('swiftPayments.payeeName')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    :maxlength="payeeNameMaxLen
                      ? payeeNameMaxLen
                      : false"
                    filled
                    class="transferFunds--custom-textfield"
                  />
                  <v-checkbox
                    v-model="payeeForm.selectedIBANValue"
                    label="IBAN (eg GB36MODL08888800227919)"
                    class="ma-0 pa-0 test">
                  </v-checkbox>
                  <v-text-field
                    v-model="payeeForm.selectedToAccount"
                    :label="payeeForm.selectedIBANValue ? $t('swiftPayments.selectPayeeLabelIBAN') : $t('swiftPayments.selectPayeeLabel')"
                    :color="primaryColor"
                    :rules="[
                      rules.requiredRule,
                      rules.swiftToAccountNumericRule,
                    ]"
                    :error="isInvalidIBAN"
                    :error-messages="
                      isInvalidIBAN
                      ? $t('internationalPayments.deriveBICError')
                      : ''
                    "
                    ref="toAccField"
                    :maxlength="toAccMaxLength"
                    filled
                    class="transferFunds--custom-textfield ma-0 pa-0"
                    @keydown="
                      $formatter.validateNumberInput($event)
                    "
                    onCopy="return false"
                    onpaste="return false"
                    @input="clearBICError"
                    @blur="payeeForm.selectedIBANValue && getBICFromIBAN()"
                  ></v-text-field>
                  <!--BIC/Swift-->
                  <v-text-field
                    :readonly="payeeForm.selectedIBANValue"
                    v-model="payeeForm.selectedBicCode"
                    :color="primaryColor"
                    :label="
                      $t('swiftPayments.BICSwift')
                    "
                    :rules="[rules.requiredRule]"
                    :error="isInvalidBic"
                    :error-messages="
                      isInvalidBic
                      ? $t('internationalPayments.invalidBICError')
                      : ''
                    "
                    max-height="auto"
                    filled
                    :class="payeeForm.selectedIBANValue ? 'transferFunds--custom-disabled-textfieldb' : 'transferFunds--custom-textfield'"
                    ref="swiftBicCode"
                    @blur="!payeeForm.selectedIBANValue && payeeForm.selectedBicCode && setPayeeBankDetails(payeeForm.selectedBicCode)"
                    @keydown="clearBICFieldError"
                  ></v-text-field>
                  <v-select
                    v-model="payeeForm.selectedCurrencyCode"
                    :items="currencyTypes"
                    :label= "$t('swiftPayments.currency')"
                    :color="primaryColor"
                    max-height="auto"
                    autocomplete
                    :rules="[rules.requiredRule]"
                    filled
                    class="transferFunds--custom-textfield"
                  >
                  </v-select>
                  <v-select
                    v-model="payeeForm.selectedCountryCode"
                    :items="listCountryCodes"
                    :label= "$t('swiftPayments.payeeCountry')"
                    :color="primaryColor"
                    max-height="auto"
                    item-text="codeDescription"
                    item-value="codeReference"
                    autocomplete
                    :rules="[rules.requiredRule]"
                    filled
                    class="transferFunds--custom-textfield"
                  >
                  </v-select>
                  <v-text-field
                    v-model="payeeForm.town"
                    :color="primaryColor"
                    :label="
                      $t('swiftPayments.payeeTown')
                    "
                    :rules="[rules.requiredRule]"
                    filled
                    :maxlength=35
                    class="transferFunds--custom-textfield"
                  ></v-text-field>
                  <v-text-field
                    v-model="payeeForm.postCode"
                    :color="primaryColor"
                    :label="
                      $t('swiftPayments.payeePostalCode')
                    "
                    :rules="[rules.requiredRule]"
                    filled
                    :maxlength=16
                    class="transferFunds--custom-textfield"
                  ></v-text-field>
                  <SupplementaryDocuments
                    v-model="payeeForm.swiftSupplementaryDocuments"
                    :required="swiftSupplementaryConfig.required"
                    :maxFileSizeInMB="swiftSupplementaryConfig.maxFileSizeInMB"
                    :maxFileUploadCount="swiftSupplementaryConfig.maxFileUploadCount"
                    :validFileTypes="swiftSupplementaryConfig.validFileTypes"
                    :compactView="true"
                    class="pt-2"
                    />
                  <v-btn
                    @click="onAddPayee('SWIFT')"
                    :color="primaryColor"
                    :disabled="!isPayeeFormValid || !hasValidDocuments"
                    class="white--text text-capitalize py-2 px-4"
                  >
                    {{ $t("addNewPayee.addPayeeBtn") }}
                  </v-btn>
                </v-form>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-navigation-drawer>
    </v-flex>
    <v-flex v-if="!reviewScreen" xs12 sm12 md12 lg12 xl12 data-qa="swiftpayments-flex-dwscal">
      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="swiftpayments-flex-ybfo39">
        <Loader v-show="loaderEnabled" />
        <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="swiftpayments-layout-ktas29">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px' }"
           data-qa="swiftpayments-flex-mskohf">
            <v-container class="transferFunds--title-padding" data-qa="swiftpayments-container-bmyvv">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="swiftpayments-flex-p6hpwl">
                <v-row no-gutters data-qa="swiftpayments-row-vsucuc">
                  <v-layout row wrap class="pb-2" data-qa="swiftpayments-layout-n6qtql">
                    <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="swiftpayments-flex-xg4s3">
                      <v-row justify="end" data-qa="swiftpayments-row-lr9zke">
                        <v-avatar :tile="false" size="35" color="white" data-qa="swiftpayments-avatar-48r08">
                          <v-icon :color="primaryColor" data-qa="swiftpayments-icon-idquwb">mdi-sync</v-icon>
                        </v-avatar>
                      </v-row>
                    </v-flex>
                    <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="swiftpayments-flex-gb0m3l">
                      <v-row no-gutters data-qa="swiftpayments-row-0ybss">
                        <font class="text-h5 font-weight-light white--text">
                          {{ $t("swiftPayments.title") }}
                        </font>
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-flex>
            </v-container>
          </v-flex>
        </v-layout>
        <!-- Start Payment Transfer Form-->
        <v-flex
          xs12
          sm12
          md12
          lg10
          xl10
          class="transferFunds--content-padding transferFunds--overlayCardFlex"
         data-qa="swiftpayments-flex-3rlfbc">
          <v-layout row wrap class="transferFunds--content-padding" data-qa="swiftpayments-layout-taxlfk">
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="swiftpayments-flex-2t95n">
              <v-card data-qa="swiftpayments-card-54qoz">
                <v-tabs
                  v-if="enableSwiftRegisteredPayee && !isSmeLogin"
                  v-model="currentTab"
                  :color="primaryColor"
                  class="pl-9 pt-4"
                  @change="onTabChanged"
                 data-qa="swiftpayments-tabs-f5jl46">
                  <v-tabs-slider
                    :color="primaryColor"
                   data-qa="swiftpayments-tabs-slider-xth9ze"></v-tabs-slider>
                  <v-tab
                    v-for="(item, i) in transferOptionsTabs"
                    :key="item"
                    class="text-capitalize font-weight-bold"
                    :data-qa="`swiftpayments-tab-4j0v8-${i}`"
                  >
                    {{ item }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="currentTab" :color="primaryColor">
                  <v-tab-item v-if="enableSwiftRegisteredPayee && !isSmeLogin">
                    <v-container class="pt-4">
                      <v-form
                        ref="form"
                        v-model="isFormValid"
                        :lazy-validation="false">
                        <v-layout row justify-space-between>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6">
                            <PaymentSourceSelect
                              v-model="form.selectedAccount"
                              @input="verifyAccount"
                              :items="filteredSourceAccounts"
                              :label="
                                this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? $t('internationalPayments.selectAccountLabelIban') : $t('internationalPayments.selectAccountLabel')
                              "
                              :error="isFormAccounts"
                              :error-messages="isFormAccounts ? $t('internationalPayments.accountsError') : ''"
                              :rules="[rules.requiredRule || !isFormAccounts]"
                            />
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6">
                            <v-text-field
                              v-model="payeeList"
                              @focus="listPayee"
                              :color="primaryColor"
                              :rules="[rules.requiredRule || !isFormAccounts]"
                              :label="$t('internationalPayments.selectPayeeLabel')"
                              :hint="
                                payeeAccountName || selectedPayeeSortCode
                                  ? `${payeeAccountName} | ${selectedPayeeSortCode}`
                                  : ''
                              "
                              persistent-hint
                              filled
                              readonly
                              append-icon="mdi-chevron-right"
                              class="transferFunds--custom-textfield"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-7">
                            <v-row class="py-0" data-qa="swiftpayments-row-z5taux">
                              <v-col cols="8" class="py-0">
                                <v-text-field
                                v-model="form.selectedTransferAmount"
                                @input="
                                  verifyBalance();
                                  restrictDecimal($event);
                                "
                                @keypress="numbersOnly"
                                :label="$t('internationalPayments.amountLabel')"
                                :color="primaryColor"
                                :rules="[
                                  rules.requiredAmountRule,
                                  rules.isSwiftPaymentBalanceValid,
                                ]"
                                :class="[
                                  'transferFunds--custom-textfield custom-amount',
                                  'transferFunds--amountCurrencySymbolDefault',
                                  selectedTransferAmount && selectedTransferAmount.length
                                    ? false
                                    : 'transferFunds--amountCurrencySymbol',
                                ]"
                                filled
                                persistent-hint
                                type="number"
                                ref="qpAmountField"></v-text-field>
                              </v-col>
                              <v-col cols="4" class="py-0">
                                <v-select
                                  v-model="form.selectedCurrencyType"
                                  disabled
                                  :items="currencyTypes"
                                  label= "Cur"
                                  :color="primaryColor"
                                  :error="isFormAccountsQP"
                                  :error-messages="
                                      isFormAccountsQP
                                        ? $t('internationalPayments.accountsError')
                                        : ''
                                  "
                                  :rules="[rules.requiredRule || !isFormAccountsQP]"
                                  max-height="auto"
                                  autocomplete
                                  filled
                                  class="transferFunds--custom-textfield"
                                  data-qa="swiftpayments-select-5uy8zf">
                                    <template v-slot:selection="data">
                                      <v-list-item class="pa-0">
                                        {{ data.item }}
                                      </v-list-item>
                                    </template>
                                    <template v-slot:item="data">
                                        <template>
                                          {{ data.item }}
                                        </template>
                                    </template>
                                  </v-select>
                              </v-col>
                            </v-row>
                          </v-flex>
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-7 pt-4">
                            <v-menu
                                v-model="menuOneTimePayment"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                offset-y
                                transition="scale-transition"
                                min-width="290px"
                               data-qa="swiftpayments-menu-4je5kp">
                                <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="selectedPaymentDate"
                                :color="primaryColor"
                                :label="
                                  $t('swiftPayments.paymentDateLabel')
                                "
                                :rules="[rules.requiredRule]"
                                filled
                                append-icon="mdi-calendar"
                                data-qa="fromDate"
                                class="transferFunds--custom-textfield"
                              ></v-text-field>
                              </template>
                                <v-date-picker
                                  v-model="formattedDate"
                                  @input="menuOneTimePayment = false"
                                  :allowed-dates="allowedDates"
                                  :min="fromDate"
                                  :color="primaryColor"
                                  filled
                                  data-qa="fromDate"
                                  @change="repeatUpdateDateOTP"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                          <!--Charges-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6">
                            <v-select
                               v-model="form.selectedChargeOptions"
                               :items="chargesOptions"
                               label= "Charges"
                               :color="primaryColor"
                               :error="isFormAccountsQP"
                               :error-messages="
                                  isFormAccountsQP
                                    ? $t('internationalPayments.accountsError')
                                    : ''
                               "
                               :rules="[rules.requiredRule || !isFormAccountsQP]"
                               max-height="auto"
                               autocomplete
                               filled
                               class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-select-ixpty">
                              <template v-slot:selection="data">
                                <v-list-item class="pa-0">
                                  <template>
                                    {{
                                      data.item
                                    }}
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:item="data">
                                    {{
                                      data.item
                                    }} - {{
                                      $t(`swiftPayments.${data.item}`)
                                    }}
                                </template>
                            </v-select>
                          </v-flex>
                          <!-- Remarks // Customization -->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6">
                            <v-text-field
                              v-model="form.transferNote"
                              :label="$t('internationalPayments.noteLabel')"
                              :color="primaryColor"
                              :rules="
                                transferNote
                                  ? [rules.transferNoteValidation]
                                  : [rules.requiredRule]
                              "
                              filled
                              class="transferFunds--custom-textfield"
                              :maxlength="transferNoteMaxLength"></v-text-field>
                          </v-flex>
                          <v-row data-qa="swiftpayments-row-ehwh3n">
                            <v-container class="px-9" data-qa="swiftpayments-container-5k85zs">
                              <SupplementaryDocuments
                                v-model="supplementaryDocuments"
                              />
                            </v-container>
                          </v-row>
                        </v-layout>
                        <v-layout row justify-space-between>
                          <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2">
                            <v-btn
                              @click="onNextButton"
                              :color="primaryColor"
                              :disabled="
                                !isFormValid || isFormAccounts || isAccountBalance || !hasValidDocuments
                              "
                              elevation="2"
                              class="text-capitalize ma-2 white--text py-2 px-4"
                               data-qa="swiftpayments-btn-1ei6o">{{
                                $t("internationalPayments.reviewPaymentBtn")
                              }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-tab-item>
                  <v-tab-item data-qa="swiftpayments-tab-item-zeqz0f">
                    <v-container class="pt-4" data-qa="swiftpayments-container-s02u68">
                      <v-form
                        ref="form"
                        v-model="isFormValid"
                        :lazy-validation="false"
                       data-qa="swiftpayments-form-g7iaiq">
                        <v-layout row justify-space-between data-qa="swiftpayments-layout-hq3rem">
                        <!--From account-->
                        <v-flex xs12 sm12 md12 lg12 xl12 class="pa-0 ma-0" data-qa="swiftpayments-flex-zu3opz">
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-06269">
                            <PaymentSourceSelect
                              v-model="form.selectedAccount"
                              @input="verifyAccount"
                              :items="filteredSourceAccounts"
                              :label="
                                this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? $t('internationalPayments.selectAccountLabelIban') : $t('internationalPayments.selectAccountLabel')
                              "
                              :error="isFormAccounts"
                              :error-messages="isFormAccounts ? $t('internationalPayments.accountsError') : ''"
                              :rules="[rules.requiredRule || !isFormAccounts]"
                            />
                          </v-flex>
                        </v-flex>
                        <!-- Payee Name-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-kxtfq">
                            <v-text-field
                              v-model="selectedPayeeName"
                              :color="primaryColor"
                              :label="
                                $t('internationalPayments.toAcctName')
                              "
                              :rules="[rules.requiredRule, rules.validateName]"
                              filled
                              :maxlength="payeeNameMaxLen"
                              class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-text-field-rz3sgc"></v-text-field>
                          </v-flex>
                           <!-- Country of payee -->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-nioo68">
                            <v-select
                              v-model="selectedPayeeCountry"
                              :items="listCountryCodes"
                              :label= "$t('swiftPayments.payeeCountry')"
                              :color="primaryColor"
                              max-height="auto"
                              item-text="codeDescription"
                              autocomplete
                              :rules="[rules.requiredRule]"
                              filled
                              class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-select-ww6p69">
                            </v-select>
                          </v-flex>
                        <!-- Payee's Town-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-kewfq">
                            <v-text-field
                              v-model="selectedPayeeTown"
                              :color="primaryColor"
                              :label="
                                $t('swiftPayments.payeeTown')
                              "
                              :rules="[rules.requiredRule, rules.onlyAllowedCharsRule]"
                              filled
                              :maxlength="townNameMaximumLength"
                              class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-text-field-rz3sgc"></v-text-field>
                          </v-flex>
                          <!-- Payee's Postal Code -->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-kxoiy">
                            <v-text-field
                              v-model="selectedPayeePostalCode"
                              :color="primaryColor"
                              :label="
                                $t('swiftPayments.payeePostalCode')
                              "
                              :rules="[rules.requiredRule, rules.isAlphaNumericWithSpaces]"
                              filled
                              :maxlength="postalCodeMaximumLength"
                              class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-text-field-rz3sgc"></v-text-field>
                          </v-flex>
                          <!--Checkbox-->
                          <!--To Account-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6" data-qa="swiftpayments-flex-q5kvf">
                            <v-checkbox
                              v-model="selectedIBANValue"
                              label="IBAN (eg GB36MODL08888800227919)"
                              class="ma-0 pa-0 test" data-qa="swiftpayments-checkbox-kehq89">
                            </v-checkbox>
                              <v-text-field
                                v-model="selectedToAccount"
                                :label="selectedIBANValue ? $t('swiftPayments.selectPayeeLabelIBAN') : $t('swiftPayments.selectPayeeLabel')"
                                :color="primaryColor"
                                :rules="[
                                  rules.requiredRule,
                                  rules.isAlphaNumericRule,
                                ]"
                                :error="isInvalidIBAN"
                                :error-messages="
                                  isInvalidIBAN
                                  ? $t('internationalPayments.deriveBICError')
                                  : ''
                                "
                                ref="toAccField"
                                :maxlength="toAccMaxLength"
                                filled
                                class="transferFunds--custom-textfield ma-0 pa-0"
                                @keydown="
                                  $formatter.validateNumberInput($event)
                                "
                                onCopy="return false"
                                onpaste="return false"
                                @input="clearBICError"
                                @blur="verifyAccount(); selectedIBANValue && getBICFromIBAN()"
                               data-qa="swiftpayments-text-field-i4qtdo"></v-text-field>
                          </v-flex>
                          <!--BIC/Swift-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-12" data-qa="swiftpayments-flex-e7pmw">
                              <v-text-field
                                :readonly="selectedIBANValue"
                                v-model="selectedBicCode"
                                :color="primaryColor"
                                :label="
                                  $t('swiftPayments.BICSwift')
                                "
                                :rules="[rules.requiredRule]"
                                :error="isInvalidBic"
                                :error-messages="
                                  isInvalidBic
                                  ? $t('internationalPayments.invalidBICError')
                                  : ''
                                "
                                max-height="auto"
                                filled
                                :class="selectedIBANValue ? 'transferFunds--custom-disabled-textfieldb' : 'transferFunds--custom-textfield'"
                                ref="swiftBicCode"
                                @blur="!selectedIBANValue && selectedBicCode && setPayeeBankDetails(selectedBicCode)"
                                @keydown="clearBICFieldError"
                               data-qa="swiftpayments-text-field-vuyv3e"></v-text-field>
                          </v-flex>
                          <!--Amount Cur-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-7" data-qa="swiftpayments-flex-m8nap">
                            <v-row class="py-0" data-qa="swiftpayments-row-z5taux">
                              <v-col cols="8" class="py-0" data-qa="swiftpayments-col-tveuus">
                                <v-text-field
                                v-model="selectedTransferAmount"
                                @input="
                                  verifyBalance();
                                  restrictDecimal($event);
                                "
                                @keypress="numbersOnly"
                                :label="$t('internationalPayments.amountLabel')"
                                :color="primaryColor"
                                :rules="[
                                  rules.requiredAmountRule,
                                  rules.isSwiftPaymentBalanceValid,
                                ]"
                                :class="[
                                  'transferFunds--custom-textfield custom-amount',
                                  'transferFunds--amountCurrencySymbolDefault',
                                  selectedTransferAmount && selectedTransferAmount.length
                                    ? false
                                    : 'transferFunds--amountCurrencySymbol',
                                ]"
                                filled
                                persistent-hint
                                type="number"
                                ref="qpAmountField"
                               data-qa="swiftpayments-text-field-ak0zi"></v-text-field>
                              </v-col>
                              <v-col cols="4" class="py-0" data-qa="swiftpayments-col-45j1rv">
                                <v-select
                               v-model="selectedCurrencyType"
                               :items="currencyTypes"
                               label= "Cur"
                               :color="primaryColor"
                               :error="isFormAccountsQP"
                               :error-messages="
                                  isFormAccountsQP
                                    ? $t('internationalPayments.accountsError')
                                    : ''
                               "
                               :rules="[rules.requiredRule || !isFormAccountsQP]"
                               max-height="auto"
                               autocomplete
                               filled
                               class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-select-5uy8zf">
                              <template v-slot:selection="data">
                                  <v-list-item class="pa-0" data-qa="swiftpayments-list-item-b7fi0k">
                                    {{ data.item }}
                                  </v-list-item>
                                </template>
                                <template v-slot:item="data">
                                    <template>
                                      {{ data.item }}
                                    </template>
                                </template>
                            </v-select>
                              </v-col>
                            </v-row>
                          </v-flex>
                          <!--Payment Date - Current Date & future date allowed -->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-7 pt-4" data-qa="swiftpayments-flex-jykzpk">
                            <v-menu
                                v-model="menuOneTimePayment"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                offset-y
                                transition="scale-transition"
                                min-width="290px"
                               data-qa="swiftpayments-menu-4je5kp">
                                <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"
                                v-model="selectedPaymentDate"
                                :color="primaryColor"
                                :label="
                                  $t('swiftPayments.paymentDateLabel')
                                "
                                :rules="[rules.requiredRule]"
                                filled
                                append-icon="mdi-calendar"
                                data-qa="fromDate"
                                class="transferFunds--custom-textfield"
                              ></v-text-field>
                              </template>
                                <v-date-picker
                                  v-model="formattedDate"
                                  @input="menuOneTimePayment = false"
                                  :allowed-dates="allowedDates"
                                  :min="fromDate"
                                  :color="primaryColor"
                                  filled
                                  data-qa="fromDate"
                                  @change="repeatUpdateDateOTP"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                          <!--Charges-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-dq31pe">
                            <v-select
                               v-model="selectedChargeOptions"
                               :items="chargesOptions"
                               label= "Charges"
                               :color="primaryColor"
                               :error="isFormAccountsQP"
                               :error-messages="
                                  isFormAccountsQP
                                    ? $t('internationalPayments.accountsError')
                                    : ''
                               "
                               :rules="[rules.requiredRule || !isFormAccountsQP]"
                               max-height="auto"
                               autocomplete
                               filled
                               class="transferFunds--custom-textfield"
                             data-qa="swiftpayments-select-ixpty">
                              <template v-slot:selection="data">
                                <v-list-item class="pa-0" data-qa="swiftpayments-list-item-r7s2u">
                                  <template>
                                    {{
                                      data.item
                                    }}
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:item="data">
                                    {{
                                      data.item
                                    }} - {{
                                      $t(`swiftPayments.${data.item}`)
                                    }}
                                </template>
                            </v-select>
                          </v-flex>
                          <!--Remarks-->
                          <v-flex xs12 sm12 md6 lg6 xl6 class="px-6 pt-6" data-qa="swiftpayments-flex-hbvfb">
                            <v-text-field
                              v-model="transferNote"
                              :label="$t('internationalPayments.noteLabel')"
                              :color="primaryColor"
                              :rules="
                                transferNote
                                  ? [rules.transferNoteValidation]
                                  : [rules.requiredRule]
                              "
                              filled
                              class="transferFunds--custom-textfield"
                              :maxlength="transferNoteMaxLength"
                             data-qa="swiftpayments-text-field-ufy53s"></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-row data-qa="swiftpayments-row-ehwh3n">
                          <v-container class="px-9" data-qa="swiftpayments-container-5k85zs">
                            <SupplementaryDocuments
                              v-model="supplementaryDocuments"
                            />
                          </v-container>
                        </v-row>
                        <v-layout row justify-space-between data-qa="swiftpayments-layout-t5nev">
                          <v-flex xs11 sm11 md5 lg5 xl5 class="pl-4 py-2" data-qa="swiftpayments-flex-m7o9x">
                            <v-btn
                              @click="onNextButton"
                              :color="primaryColor"
                              :disabled="
                                !isFormValid || isFormAccounts || isAccountBalance || !hasValidDocuments
                              "
                              elevation="2"
                              class="text-capitalize ma-2 white--text py-2 px-4"
                               data-qa="swiftpayments-btn-1ei6o">{{
                                $t("internationalPayments.reviewPaymentBtn")
                              }}</v-btn
                            >
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex v-else data-qa="swiftpayments-flex-98of6t">
      <SwiftPaymentsReview
        @refreshAccounts="getListofAccounts"
        :config="{ payload }"
        :display="{ viewOnly }"
      />
    </v-flex>
    <!-- Add new payee OTP section -->
    <Modal
      v-if="enableOTPToAddPayee && showOTPScreen"
      @cancel="onOtpModalClose"
      :config="modalConfig.otp"
    >
      <span slot="modalContent" data-qa="swiftpayments-span-gb0nx6">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/pages/login/login.scss'
import '@/styles/pages/transferFunds.scss'
import OtpInput from '@/components/common/OtpInput.vue'
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import { mask } from 'vue-the-mask'
import event from '@/util/event'
import moment from 'moment'
import SwiftPaymentsReview from '@/views/payments/InterBankPayments/SwiftPayments/SwiftPaymentsReview.vue'
import Loader from '@/components/common/Loader.vue'
import swiftTemplate from '@/plugins/swiftConfig'
import PaymentSourceSelect from '../../../common/PaymentSourceSelect.vue'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'SwiftPayments',
  components: {
    Loader,
    OtpInput,
    SwiftPaymentsReview,
    Modal: () => import('@/components/common/Modal.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    SupplementaryDocuments: () => import('@/views/payments/InterBankPayments/common/SupplementaryDocuments.vue'),
    PaymentSourceSelect
  },
  mixins: [ smeRolesMixin ],
  directives: { mask },
  data () {
    return {
      swiftTemplate,
      isInvalidBic: false,
      payeeBank: {},
      selectedCurrencyType: '',
      selectedPaymentDate: '',
      selectedPayeeName: '',
      selectedPayeeTown: '',
      selectedTransferAmount: '',
      selectedBicCode: '',
      selectedToAccount: '',
      selectedChargeOptions: '',
      chargesOptions: '',
      currencyTypes: this.$appSettings.swiftCurrencyFormats,
      selectedIBANValue: false,
      isInvalidIBAN: false,
      selectedPayeeCountry: '',
      selectedPayeePostalCode: '',
      toAccMaxLength: this.$appSettings.defaultConfigurations.fundTransferQuickPayToAccMaxlengthIBAN,
      valid: true,
      reviewScreen: false,
      isInitiateSepaFailed: false,
      isFormValid: false,
      isPayeeFormValid: false,
      isFormAccounts: false,
      isFormAccountsQP: false,
      isAccountBalance: false,
      loaderEnabled: false,
      enablePayeeForm: false,
      menu: false,
      menuOneTimePayment: false,
      search: '',
      searchPayee: '',
      listOfAccounts: [],
      listCountryCodes: [],
      payload: {},
      viewOnly: {},
      isLeavingRoute: false,
      selectedAccount: undefined,
      selectedAccountNumber: '',
      selectedAccountNumberCurrency: '',
      payeeAccount: '',
      payeeAccountName: '',
      searchPayeeList: '',
      selectPayee: '',
      transferAmount: [],
      paymentFrequency: '',
      frequencyMonths: '',
      transferNote: '',
      payeeList: '',
      selectedPayeeSortCode: '',
      fromDate: moment().format('YYYY-MM-DD'),
      todaysDate: moment().format('YYYY-MM-DD'),
      repeatFromDate: moment().format('YYYY-MM-DD'),
      repeatMinAllowedDate: moment().format('YYYY-MM-DD'),
      repeatFormattedDate: '',
      formattedDate: '',
      // selectedPaymentDate: new Date().toISOString().substr(0, 10),
      minAllowedDate: moment().format('YYYY-MM-DD'),
      enableOTPToAddPayee:
        this.$appSettings.defaultConfigurations.enableOTPToAddPayee,
      enableOTPToSwiftPayment:
        this.$appSettings.defaultConfigurations.enableOTPToSwiftPayment,
      enableRecurringPaymentsOption:
        this.$appSettings.defaultConfigurations.payments.enableRecurringPaymentsOption,
      otpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      linkedNominatedAccDetails: {},
      isNominatedAccount: false,
      showOTPScreen: false,
      isLogout: false,
      paymentMode: 0,
      showLinkedAccounts: 0,
      isTransferComplete: false,
      internationalPaymentCharges: undefined,
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        }
      },
      enableEBAVCheckForAddPayee: this.$appSettings.defaultConfigurations.enableEBAVCheckForAddPayee,
      bankName: this.$appSettings.applicationSettings.bankName,
      beneficiaryList: [],
      noteRules: [
        (v) => !!v || 'Note is required',
        (v) => (v && v.length >= 5) || 'Note must be greater than 5 characters'
      ],
      fieldRules: (v) => !!v || 'Required Field',
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        requiredAmountRule: (v) =>
          (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired'),
        lengthRange: (value, min, max) =>
          (value && (value.length > min || value.length < max)) ||
          `Enter atleast ${min} characters`,
        minLength: (value, min) =>
          (value && value.length >= min) || `Enter atleast ${min} characters`,
        minValue: (v) => v >= 2 || this.$t('transferfunds.numberOfPaymentsMinValidation'),
        maxValue: (v) => v <= 10 || this.$t('transferfunds.numberOfPaymentsMaxValidation'),
        isAlphaNumericWithSpaces: (v) => {
          if (v) {
            return (/^[a-zA-Z0-9 ]+$/.test(v) || this.$t('errors.common.invalidInput'))
          } else return 'Required Field'
        },
        isAlphaNumericRule: (v) => {
          if (v) {
            return (
              new RegExp('^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$', 'g').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        },
        validateName: (v) => {
          if (v) {
            return (
              new RegExp('^([^!@#\\$%\\^&\\*][a-zA-Z\\.\'\\s]*)$', 'g').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        },
        onlyAllowedCharsRule: (v) => {
          if (v) {
            return (
              new RegExp('^[A-Za-z0-9&\'*.,#\\-"/() ]+$').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return this.$t('errors.common.requiredField')
        },
        numberTypeCheck: (v) =>
          new RegExp('^\\d+(.\\d\\d?)?$').test(v) ||
          this.$t('errors.common.invalidInput'),
        transferNoteValidation: (v) =>
          new RegExp("^[a-zA-Z0-9 /\\-?:\\()\\.,']*$").test(v) ||
          this.$t('errors.common.invalidChar'),
        isSwiftPaymentBalanceValid: (v) => {
          let tempValue = v
          if (tempValue) {
            tempValue = tempValue.toString().replace(',', '.')
            return tempValue && tempValue > 0
              ? !this.isAccountBalance ||
              this.$t('transferfunds.fundsError')
              : new RegExp('^0*(.0*)$').test(tempValue)
                ? this.$t('errors.common.minAmountError')
                : false
          } else {
            return false
          }
        },
        swiftToAccountNumericRule: (v) => {
          if (v) {
            return (
              new RegExp('^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$', 'g').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        }
      },
      isOwnAccLinked: null,
      transferNoteMaxLength: '',
      townNameMaximumLength: '',
      postalCodeMaximumLength: '',
      payeeNameMaxLen:
          this.$appSettings.defaultConfigurations.payeeNameMaxlength.swift,
      appSettingsNA: this.$appSettings.defaultConfigurations.nominatedAccounts,
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      supplementaryDocuments: [],
      form: {
        selectedAccount: null
      },
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      currentTab: 0,
      transferOptionsTabs: [
        this.$t('swiftPayments.registeredPayeeTitle'),
        this.$t('swiftPayments.quickPaymentTitle')
      ],
      openPayee: false,
      enableSwiftRegisteredPayee: this.$appSettings.defaultConfigurations.nominatedAccounts.enableSwiftRegisteredPayee,
      enableSwiftPayee: this.$appSettings.defaultConfigurations.nominatedAccounts.enableSwiftPayee,
      payeeForm: {
        accountName: '',
        selectedToAccount: '',
        selectedBicCode: '',
        selectedCurrencyCode: '',
        selectedCountryCode: '',
        town: '',
        postCode: '',
        selectedIBANValue: false,
        swiftSupplementaryDocuments: []
      }
    }
  },

  async created () {
    this.transferNoteMaxLength = this.swiftTemplate.remarksMaxLength
    this.townNameMaximumLength = this.swiftTemplate.townNameMaxLength
    this.postalCodeMaximumLength = this.swiftTemplate.postalCodeMaxLength
    this.selectedChargeOptions = this.form.selectedChargeOptions = this.swiftTemplate.swiftChargesOptions[0]
    this.chargesOptions = this.swiftTemplate.swiftChargesOptions
    const self = this
    this.getGenericCodes()
    this.getActiveCurrencyFromService()
    this.selectedPaymentDate = this.$formatter.formatDate(this.todaysDate)

    await self.getListofAccounts()

    if (this.$route.params && this.$route.params.payeeAccount) {
      this.togglePayee(this.$route.params.payeeAccount)
    }

    event.$on('IS_REVIEW_CLEAR', ({ type }) => {
      this.reviewScreen = false
      if (type === 'Reset') {
        setTimeout(() => {
          this.resetPage()
        }, 100)
      }
    })
    event.$on('is_TransferComplete', (status) => {
      this.isTransferComplete = status
      if (this.isTransferComplete) {
        this.isFormAccounts = false
        this.isFormAccountsQP = false
        this.selectedAccountNumber = ''
        this.selectedToAccount = ''
        this.form.selectedAccount = null
      }
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.enableOTPToAddPayee && this.showOTPScreen) {
        this.modalConfig.otp.enableSave = false
        this.addNewPayee()
      } else {
        this.modalConfig.otp.enableSave = true
      }
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  computed: {
    payeeSearchFilter () {
      if (!this.beneficiaryList?.length) return []
      const matchesSearch = (item) => {
        if (!this.searchPayee) return true
        return (
          item.name.toLowerCase().includes(this.searchPayee.toLowerCase()) ||
          item.beneficiaryAccountNumber.toLowerCase().includes(this.searchPayee.toLowerCase())
        )
      }
      return this.beneficiaryList
        .filter(item => matchesSearch(item)
        )
    },
    filteredSourceAccounts () {
      /** select only Current and Savings Accounts as the funding accounts. ISA, Term Deposits and Loan Accounts are not available as funding accounts. */
      if (this.listOfAccounts.length) {
        const NODRfilterAccounts = this.listOfAccounts.filter((item) => {
          return (
            item.postingsRestriction !== 'DEBIT' && !['NACC', 'TXFR', 'TXEA', 'TXNA', 'TXSV', 'TXLA'].includes(item.accountType)
          )
        })
        const validModeOfOperationAccounts = NODRfilterAccounts.filter((item) => {
          return !(item.accountOwnership === 'JOINT' && this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList.includes(item.modeOfOperation.code))
        })
        return validModeOfOperationAccounts
      } else return []
    },
    hasValidDocuments () {
      if (!this.swiftSupplementaryConfig.required && this.supplementaryDocuments.length === 0) return true

      return this.supplementaryDocuments.length > 0 && !this.supplementaryDocuments.some(file => file.error)
    },
    hasValidPayeeDocuments () {
      if (!this.settings.documentsRequired && this.payeeForm.swiftSupplementaryDocuments.length === 0) return true

      return this.payeeForm.swiftSupplementaryDocuments.length > 0 && !this.payeeForm.swiftSupplementaryDocuments.some(file => file.error)
    },
    settings () {
      return {
        documentsRequired: this.$appSettings.defaultConfigurations.supplementaryDocuments.required
      }
    },
    swiftSupplementaryConfig () {
      const { SWIFT } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments
      return {
        enabled: SWIFT.enabled,
        required: SWIFT.required,
        maxFileSizeInMB: SWIFT.maxFileSizeInMB,
        maxFileUploadCount: SWIFT.maxFileUploadCount,
        validFileTypes: SWIFT.validFileTypes
      }
    }
  },
  methods: {
    async getActiveCurrencyFromService () {
      const response = await commonService.getActiveCurrencyFromService()
      this.currencyTypes = response.items
      return this.currencyTypes
    },
    async getGenericCodes () {
      const code = {
        codeReferences: [{ reference: 'ISOCountryCode2Char' }]
      }
      const response = await commonService.getGenericCodes(code)
      if (response && response.aggregateCodes && response.aggregateCodes[0]) {
        if (response.aggregateCodes[0].codes) {
          this.listCountryCodes = response.aggregateCodes[0].codes
        }
      }
    },
    numbersOnly (e) {
      if (['e', '+', '-'].includes(e.key)) {
        e.preventDefault()
      }
    },
    clearBICFieldError () {
      if (this.isInvalidBic) {
        this.isInvalidBic = false
        this.$refs.swiftBicCode.resetValidation()
      }
    },
    clearBICError () {
      /** Capitalize text on to account input field */
      if (this.selectedIBANValue && this.selectedToAccount) {
        this.selectedToAccount = this.selectedToAccount.toUpperCase()
      }

      if (this.isInvalidIBAN) {
        this.isInvalidIBAN = false
      }
      /** Clear and reset the BIC Code field if the field already has a value and user tries to edit the To IBAN */
      if (this.selectedBicCode) {
        this.selectedBicCode = ''
        this.$refs.swiftBicCode.reset()
      }
      if (this.isInvalidBic) this.isInvalidBic = false
    },
    getIBAN () {
      if (this.payeeForm.reEnteredToAccount && this.payeeForm.reEnteredToAccount.length) {
        return `IBAN-${this.payeeForm.reEnteredToAccount.length}`
      }
    },
    filterKey (e) {
      const key = e.key
      if (key === '.' || key === 'e') { return e.preventDefault() }
    },
    formatIBAN () {
      /** Capitalize text on to account input field */
      this.payeeForm.reEnteredToAccount = this.payeeForm.reEnteredToAccount.toUpperCase()
      if (this.payeeForm.reEnteredToAccount && this.payeeForm.reEnteredToAccount.length && this.payeeForm.reEnteredToAccount.length > 3) {
        let data = ''
        data = this.payeeForm.reEnteredToAccount.replace(/\s+/g, '')
        const res = data.substr(0, 4) + ' ' + data.substr(4, 4) + ' ' + data.substr(8, 4) + ' ' + data.substr(12, 4) + ' ' + data.substr(16, 4) + ' ' + data.substr(20, 4) + ' ' + data.substr(24, 4)
        if (res.trim().length > 28) {
          this.payeeForm.reEnteredToAccount = res.trim().substring(0, 34)
        } else {
          this.payeeForm.reEnteredToAccount = res.trim()
        }
      }
    },
    showDivider (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    restrictDecimal (val) {
      if (val && val.length) {
        const newAmt = val.match(/^\d+\.?\d{0,2}/)
        this.selectedTransferAmount = newAmt[0]
      }
    },
    maskSortCode (code) {
      let maskedCode = ''
      if (code) {
        const sortCode = code.toString()
        for (let i = 0; i < sortCode.length; i++) {
          if (i % 2 === 0) {
            maskedCode = maskedCode + sortCode.substr(i, 2)
          } else if (i !== sortCode.length - 1) {
            maskedCode = maskedCode + '-'
          }
        }
      }
      return code ? maskedCode : ''
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    convertToCapitalisedSentence (sentence) {
      let capitalizedSentence = ''
      if (sentence) {
        const words = sentence.split(' ')
        capitalizedSentence = words
          .map((word) => {
            return word[0].toUpperCase() + word.substring(1).toLowerCase()
          })
          .join(' ')
      }

      return sentence ? capitalizedSentence : ''
    },
    repeatUpdateDateOTP () {
      this.selectedPaymentDate = this.$formatter.formatDate(this.formattedDate)
    },
    async resetPage () {
      // clears all fields
      if (this.$refs.form) {
        this.$refs.form.reset()
        this.fromDate = moment().format('YYYY-MM-DD')
        this.selectedPaymentDate = await this.$formatter.formatDate(this.fromDate)
      }

      // resets screens
      this.reviewScreen = false
      this.isFormValid = false
      this.isAccountBalance = false
      this.selectedPayeeSortCode = ''
      this.payeeAccountName = ''
      this.supplementaryDocuments = []
      setTimeout(() => {
        this.resetDate()
        this.repeatResetDate()
      }, 100)
    },
    async accountEbavCheck () {
      try {
        const validatePayload = {
          accountNumber: this.payeeForm.reEnteredToAccount.replace(/\s+/g, ''),
          bicCode: this.removeMasking(this.payeeForm.sortCode)
        }
        const response = await commonService.accountEbavCheck(validatePayload)
        if (response && !response.causes && response.externalBankAccountVerification) {
          this.createPayeeInit()
        } else {
          this.$store.dispatch('appStore/setAppData', {
            message: {
              title: 'Error',
              width: 400,
              persistent: true,
              saveButton: this.$t('common.okay'),
              content: this.$t('domesticPayments.validatePayeeError'),
              type: 'error',
              component: 'dob-modal'
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    async setPayeeBankDetails (bicCode) {
      const payload = {
        networkName: 'SWIFT',
        bankIdentifier: bicCode
      }
      const payeeBankDetails = await commonService.searchUkfpsSortCode(payload)
      this.payeeBank = payeeBankDetails?.find(detail => detail.address)
      this.isInvalidBic = !this.payeeBank
    },
    async getBICFromIBAN () {
      try {
        const toAccount = this.enablePayeeForm ? this.payeeForm.selectedToAccount.replace(/\s+/g, '') : this.selectedToAccount.replace(/\s+/g, '')
        if (toAccount.length) {
          const response = await commonService.getBICFromIBAN(toAccount)
          if (response && response.valid && !response.causes) {
            if (this.selectedToAccount && !this.enablePayeeForm) {
              this.selectedBicCode = response.ibanBic
              await this.setPayeeBankDetails(this.selectedBicCode)
            } else if (this.enablePayeeForm) {
              this.payeeForm.selectedBicCode = response.ibanBic
              await this.setPayeeBankDetails(this.payeeForm.selectedBicCode)
            }
          } else {
            this.isInvalidIBAN = true
            this.$store.dispatch('appStore/setAppData', {
              message: {
                title: 'Error',
                width: 400,
                persistent: true,
                btn1Label: this.$t('common.okay'),
                content: this.$t('internationalPayments.deriveBICError'),
                type: 'error',
                component: 'dob-modal'
              }
            })
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getListofAccounts () {
      this.loaderEnabled = true
      let accounts = await preload.getAllCASAWithBalance(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
      this.listOfAccounts = this.getFilteredAccounts(accounts)
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    clearSearch () {
      this.search = ''
    },
    updateDate () {
      this.formattedDate = this.$formatter.formatDate(this.fromDate)
    },
    resetDate () {
      this.formattedDate = this.fromDate
      this.selectedPaymentDate = this.$formatter.formatDate(this.todaysDate)
    },
    verifyAccount (triggeredFrom = undefined) {
      this.listOfAccounts.forEach((acc) => {
        if (acc.accountId === this.selectedAccountNumber) {
          this.selectedAccount = acc
          this.isFormAccounts = this.selectedAccountNumber === this.selectedToAccount
          if (this.selectedTransferAmount && this.selectedTransferAmount.toString().replace(',', '.')) {
            this.verifyBalance()
            this.$refs.qpAmountField.validate()
          }
        }
      })
    },
    verifyBalance () {
      const temp = this.selectedAccount ? this.selectedAccount.balance : ''
      if (this.selectedTransferAmount > 0 &&
          this.selectedTransferAmount <= temp) {
        this.isAccountBalance = false
      } else this.isAccountBalance = true
    },
    nextValidate (type) {
      this.reviewScreen = true
      this.$refs.form.validate()
      this.payload = {
        fromAcc: this.selectedAccountNumber,
        payeeName: this.selectedPayee ? this.selectedPayee.name : this.selectedPayeeName,
        payeeTown: this.selectedPayee ? this.selectedPayee.twnNm || this.selectedPayee.town : this.selectedPayeeTown,
        payeeCountry: this.selectedPayee ? this.getCountryDesciption(this.selectedPayee.ctry || this.selectedPayee.country) : this.selectedPayeeCountry,
        payeePostalCode: this.selectedPayee ? this.selectedPayee.pstCd || this.selectedPayee.postCode : this.selectedPayeePostalCode,
        toAccount: this.selectedPayee ? this.selectedPayee.beneficiaryAccountNumber || this.selectedPayee.accNo : this.selectedToAccount,
        bicCode: this.selectedPayee ? this.selectedPayee.beneficiaryBankBic || this.selectedPayee.sortCode : this.selectedBicCode,
        transferAmount: this.selectedTransferAmount,
        currencyType: this.selectedPayee ? this.selectedPayee.currency : this.selectedCurrencyType,
        paymentDate: this.selectedPaymentDate,
        chargesOptions: this.selectedChargeOptions,
        payeesBank: this.payeeBank,
        remarks: this.selectedPayee ? this.form.transferNote : this.transferNote,
        supplementaryDocuments: this.supplementaryDocuments,
        fromAccount: this.form.selectedAccount
      }
      this.viewOnly = {
        fromAcc: this.selectedAccountNumber,
        fromAccType: this.selectedAccount.accountType,
        payeeName: this.selectedPayee ? this.selectedPayee.name : this.selectedPayeeName,
        payeeTown: this.selectedPayee ? this.selectedPayee.twnNm || this.selectedPayee.town : this.selectedPayeeTown,
        payeeCountry: this.selectedPayee ? this.getCountryDesciption(this.selectedPayee.ctry || this.selectedPayee.country) : this.selectedPayeeCountry,
        payeePostalCode: this.selectedPayee ? this.selectedPayee.pstCd || this.selectedPayee.postCode : this.selectedPayeePostalCode,
        toAccount: this.selectedPayee ? this.selectedPayee.beneficiaryAccountNumber || this.selectedPayee.accNo : this.selectedToAccount,
        bicCode: this.selectedPayee ? this.selectedPayee.beneficiaryBankBic || this.selectedPayee.sortCode : this.selectedBicCode,
        transferAmount: this.selectedTransferAmount,
        currencyType: this.selectedPayee ? this.selectedPayee.currency : this.selectedCurrencyType,
        paymentDate: this.selectedPaymentDate,
        chargesOptions: this.selectedChargeOptions,
        payeesBank: `${this.payeeBank.instname},${this.payeeBank.address},${this.payeeBank.city},${this.payeeBank.countryname}`,
        remarks: this.selectedPayee ? this.form.transferNote : this.transferNote,
        ibanCheck: this.selectedIBANValue,
        payeesBankCountry: this.payeeBank.countryname
      }
    },
    isAnyInputsFilled () {
      return Boolean(
        this.selectedAccountNumber ||
            this.payeeAccount ||
            (this.selectedTransferAmount && this.selectedTransferAmount.length)
      )
    },
    async getExistingPayeeList () {
      try {
        const response = await commonService.getBeneficiaries(
          JSON.parse(sessionStorage.getItem('username'))
        )
        if (response && response.items) {
          this.beneficiaryList = response.items
        }
      } catch (e) {
        console.log(e)
      }
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    getPayeeDetails () {
      const self = this
      for (const item of this.beneficiaryList) {
        if (item.accountIdentification === self.payeeAccount) return item
      }
      return false
    },
    getIBANvalue (accountNumber) {
      for (const item of this.filteredSourceAccounts) {
        if (item.accountId === accountNumber) {
          return item.iban
        }
      }
      return false
    },
    repeatUpdateDate () {
      this.repeatFromDate = this.$formatter.formatDate(this.repeatFormattedDate)
    },
    repeatResetDate () {
      this.repeatFromDate = this.$formatter.formatDate(this.repeatMinAllowedDate)
      this.repeatFormattedDate = (moment(moment(this.repeatFromDate, 'YYYY-MM-DD', true)).isValid()) ? this.repeatFromDate : (this.repeatFromDate ? moment(this.repeatFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '')
    },
    onNextButton () {
      this.nextValidate()
    },
    getCountryDesciption (code) {
      const country = this.listCountryCodes.find(item => item.codeReference === code)
      return country ? country.codeDescription : ''
    },
    onTabChanged () {
      this.supplementaryDocuments.length = 0
      this.selectedAccount = null
      this.form.selectedAccount = null
      this.selectedTransferAmount = null
      this.form.selectedTransferAmount = null
      this.form.selectedCurrencyType = null
      this.payeeList = []
      this.form.transferNote = null
      this.selectedChargeOptions = this.form.selectedChargeOptions = this.swiftTemplate.swiftChargesOptions[0]
      this.selectedPayee = null
      this.openPayee = false
      this.payeeAccountName = ''
      this.selectedPayeeSortCode = ''
    },
    listPayee () {
      if (!this.linkedNominatedAccDetails.payawayAccountId) {
        if (!this.openPayee) {
          this.getExistingSwiftPayeeList()
        }
        this.openPayee = !this.openPayee
      }
    },
    async getExistingSwiftPayeeList () {
      try {
        const response = await commonService.getSwiftBeneficiaries(JSON.parse(sessionStorage.getItem('username')))
        if (response && response.items) {
          this.beneficiaryList = response.items
        }
      } catch (e) {
        console.log(e)
      }
    },
    onClosePayeeDrawer () {
      if (!this.enablePayeeForm) {
        this.openPayee = !this.openPayee
      }
      if (this.enablePayeeForm) {
        this.enablePayeeForm = false
        // clears all fields
        if (this.$refs.payeeForm) {
          this.$refs.payeeForm.reset()
        }
      }
    },
    togglePayee (index) {
      this.form.selectedCurrencyType = index.currency
      this.selectedPayee = index
      this.payeeList = index.name
      this.payeeAccountName = index.beneficiaryAccountNumber
      this.selectedPayeeSortCode = index.beneficiaryBankBic
      if (this.openPayee) { this.openPayee = !this.openPayee }
      this.verifyAccount('selectPayee')
      this.setPayeeBankDetails(index.beneficiaryBankBic || index.sortCode)
    },
    onAddPayee () {
      if (this.enableOTPToAddPayee) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.addNewPayee()
      }
    },
    buildFormData (payload) {
      const {
        businessType,
        docCategory,
        docType
      } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments.SWIFT
      const form = new FormData()
      form.append('businessType', businessType)
      form.append('businessValue', payload.beneficiaryId)
      form.append('docCategory', docCategory)
      form.append('docType', docType)
      form.append('userId', payload.customerId)

      const filenames = []
      this.payeeForm.swiftSupplementaryDocuments.forEach(file => {
        form.append('document', file)
        filenames.push(file.name)
      })
      form.append('docReferences', JSON.stringify(filenames))
      form.append('payload', JSON.stringify(payload))
      return form
    },
    async addNewPayee () {
      const data = {
        customerId: JSON.parse(sessionStorage.getItem('username')),
        name: this.payeeForm.accountName,
        beneficiaryId: uuidv4().replace(/-/g, '').substring(0, 30),
        beneficiaryAccountType: 'IBAN',
        beneficiaryAccountNumber: this.payeeForm.selectedToAccount,
        beneficiaryBankBic: this.payeeForm.selectedBicCode,
        currency: this.payeeForm.selectedCurrencyCode,
        paymentSystem: 'SWIFT',
        ctry: this.payeeForm.selectedCountryCode,
        pstCd: this.payeeForm.postCode,
        twnNm: this.payeeForm.town
      }
      let form
      const hasDocuments = this.payeeForm.swiftSupplementaryDocuments?.length >= 1
      if (hasDocuments) {
        form = this.buildFormData(data)
      }
      const resp = this.payeeForm.swiftSupplementaryDocuments?.length ? await commonService.uploadAndCreatePayee('swift', form) : await commonService.createSwiftBeneficiaries(data)
      // const resp = await commonService.createSwiftBeneficiaries(data)
      this.loaderEnabled = false
      if (resp && !resp.causes) {
        this.onOtpModalClose()
        this.$refs.payeeForm.reset()
        this.enablePayeeForm = false
        this.$store.dispatch('appStore/setAppData', {
          message: {
            content: this.$t('internationalPayments.addPayeeSuccessMsg'),
            type: 'success',
            component: 'dob-snackbar'
          }
        })
        setTimeout(() => {
          this.getExistingSwiftPayeeList()
        }, 100)
      } else {
        if (resp?.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', resp)
          return
        }
        event.$emit('reset_OTPField', true)
        this.onOtpModalClose()
        this.loaderEnabled = false
        if (
          resp &&
          resp.causes[0] &&
          resp.causes[0].code === '20600064'
        ) {

        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isTransferComplete) {
      next()
    } else {
      const condition =
        this.formValid
          ? this.isTransferComplete
          : this.reviewScreen
            ? false
            : !this.isAnyInputsFilled()
      if (!condition) {
        if (this.to) {
          next()
        } else if (this.isLogout) {
          this.to = to
          this.isLeavingRoute = false
          this.$router.push('/login')
        } else {
          this.to = to
          this.isLeavingRoute = true
        }
      } else {
        next()
      }
    }
  },
  watch: {
    selectedIBANValue () {
      if (this.selectedIBANValue && this.selectedToAccount && !this.selectedBicCode) this.getBICFromIBAN()
      if (this.selectedToAccount && this.selectedBicCode) {
        this.selectedToAccount = ''
        this.selectedBicCode = ''
        this.$refs.toAccField.reset()
        this.$refs.swiftBicCode.reset()
      }
    },
    showOTPScreen () {
      if (this.enableOTPToAddPayee && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    },
    'form.selectedAccount' () {
      this.selectedAccountNumber = this.form.selectedAccount?.accountId ?? ''
      this.selectedAccount = this.form.selectedAccount
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
  }
}
</script>

<style lang="scss" scoped>
.v-input--checkbox::v-deep {
  .v-label {
    font-size: 14px;
  }
}
</style>
